<template lang="pug">
  .accordion
    slot(:selected="selected" :select="select")
    p.bottom-text(v-if="bottomText" v-html="bottomText")
</template>

<script>
  export default {
    name: "Accordion",

    props: {
      bottomText: {
        type: String,
        default: undefined,
      },
    },

    data: () => ({
      selected: undefined,
    }),

    methods: {
      select(item) {
        if (this.selected === item) {
          this.selected = undefined;
        } else {
          this.selected = item;
        }
      },
    },
  };
</script>

<style lang="stylus">
.accordion
  .row
    padding-top 1em

  .accordion-section
    position relative
    border-bottom 1px solid #ccc
    width 95%
    margin 0 auto

    &:first-of-type
      border-top 1px solid #ccc

    .question
      display block
      padding 1em 0
      padding-right 6%

    .answer
      padding-right 5%
      padding-bottom 1em

    .mr-icon
      position absolute
      right 0
      top 0.7em
      width 1.5em
      height 1.5em
      text-align center
      line-height 135%
      background-color cta-color-4
      color white
      border-radius 50%

    .caret
      position absolute
      top 1.5em
      right 1em
      height 0
      width 0
      border 0.5em solid transparent
      border-left-width 0.45em
      border-right-width 0.45em
      border-top-color color-black

    .answer-wrap
      max-height 0
      overflow hidden
      -moz-transition max-height 0.4s ease-in-out
      -ms-transition max-height 045s ease-in-out
      -o-transition max-height 0.4s ease-in-out
      -webkit-transition max-height 0.4s ease-in-out
      transition max-height 0.4s ease-in-out

    &.open
      .caret
        border-top-color transparent
        border-bottom-color color-black
        top 1em

      .answer-wrap
        max-height 50em
        -moz-transition max-height 0.75s ease-in-out
        -ms-transition max-height 0.75s ease-in-out
        -o-transition max-height 0.75s ease-in-out
        -webkit-transition max-height 0.75s ease-in-out
        transition max-height 0.75s ease-in-out

        table, th, td
          border 1px solid black
          text-align center

    ul, li
      display list-item
      list-style-position outside
      list-style-type disc
      position relative
      padding 0.25em 0
      padding-left 2em

  .bottom-text
    padding 1em 2.5%
    padding-top 1.5em

  @media mq-tablet
    .accordion-section
      .question
      .answer
        padding-right 10%

  @media mq-desktop-md
    .accordion-section
      width 85%

      .question
      .answer
        padding-right 10%

    .bottom-text
      padding 1em 7.5%
      padding-top 1.5em

  @media mq-desktop-plus
    .accordion-section
      width 80%

      .question
      .answer
        padding-right 10%

    .bottom-text
      padding 1em 19%
      padding-top 1.5em
</style>
